"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MINT_OPTION_FEE_DENOMINATOR = exports.MINT_OPTION_FEE_PRECISION = exports.COMBO_SIZE_PRECISION = exports.MAX_COMBO_OPTION_LEGS = exports.COMBO_OPTION_TOKEN_MINT_AMOUNT = exports.OPTION_DECIMAL_ADJUSTMENT = void 0;
exports.OPTION_DECIMAL_ADJUSTMENT = 5;
exports.COMBO_OPTION_TOKEN_MINT_AMOUNT = 10000;
exports.MAX_COMBO_OPTION_LEGS = 10;
exports.COMBO_SIZE_PRECISION = 3;
// Fee is in units of a thousandth of a percent or a tenth of a basis point
exports.MINT_OPTION_FEE_PRECISION = 5;
exports.MINT_OPTION_FEE_DENOMINATOR = Math.pow(10, exports.MINT_OPTION_FEE_PRECISION);
